import { ConfiguratorGroupDto, ConfiguratorPresetGroupDto } from '@/services/configurator';
import { OptionPresetGroupType } from '@/services/option-preset/option-preset-group';

// An option belongs to a style when its `presets` list references that style id. Option presets
// carry `presetId` (the style's id) via the merged ConfiguratorPresetDto declaration.
const optionInStyle = (option: ConfiguratorGroupDto['options'][number], styleId: number): boolean =>
    option.presets?.some((p) => p.presetId === styleId) ?? false;

const groupAppliesToRoom = (
    group: ConfiguratorPresetGroupDto,
    roomOptions: ConfiguratorGroupDto['options']
): boolean => group.styles.some((s) => roomOptions.some((o) => optionInStyle(o, s.id)));

/**
 * The style groups to show in a room's Styles section, ordered room-scoped first, then applicable
 * global groups. A global/Main style group (roomId === null) applies across all rooms, so it's shown
 * only in rooms that actually contain an option belonging to one of its styles.
 *
 * `roomGroups` must be the room's FULL option groups (unfiltered by category), so filtering the
 * option list never hides an associated style group.
 */
export function styleGroupsForRoom(
    styleGroups: ConfiguratorPresetGroupDto[],
    roomGroups: ConfiguratorGroupDto[],
    roomId: number
): ConfiguratorPresetGroupDto[] {
    const roomOptions = roomGroups.flatMap((g) => g.options);
    const roomScoped = styleGroups.filter((g) => g.roomId === roomId);
    const globalApplicable = styleGroups.filter(
        (g) => g.roomId == null && g.type === OptionPresetGroupType.Main && groupAppliesToRoom(g, roomOptions)
    );
    return [...roomScoped, ...globalApplicable];
}
